/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Írj be valamit…',
  'fabric.editor.editorAssistiveLabel': 'Fő tartalmi terület, kezdj el gépelni a szöveg beviteléhez.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Súgópanel megnyitása',
};
